export default __webpack_public_path__ + "static/media/tutorial-install-bot-4.72420c8b.png";